import type { FC } from 'react';
import type { ExpandableAreaKeyProp } from '@makemydeal/dr-dash-components';
import { DEFAULT_EXPANDABLE_ID, useExpandableArea } from '@makemydeal/dr-dash-components';
import { ChevronRightIcon } from '@interstate/components/Icons';
import { Typography } from '@interstate/components/Typography';
import { ToggleHeaderContainer, ToggleHeaderAction } from './OutsideLienholder.style';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { OUTSIDE_LIENHOLDER_HEADER_NAME } from './constants';

export type OutsideLienholderToggleHeaderProp = ExpandableAreaKeyProp;

/**
 * A trigger component to toggle collapse with an associated CollapsibleArea. Use collapsibleId to differentiate areas when using multiple. Expanded and collapsed text props are Show/Hide by default.
 * @param props
 */
export const OutsideLienholderToggleHeader: FC<OutsideLienholderToggleHeaderProp> = ({ expandableId = DEFAULT_EXPANDABLE_ID }) => {
    const { doToggle, isExpanded } = useExpandableArea();
    const expanded = isExpanded(expandableId);
    const theme = useInterstateTheme();

    const handleClick = (e: React.MouseEvent | React.KeyboardEvent) => {
        e.stopPropagation();
        doToggle(expandableId);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleClick(e);
        }
    };

    return (
        <>
            <ToggleHeaderContainer>
                <ToggleHeaderAction
                    onClick={handleClick}
                    data-testid="outside-lienholder-toggle"
                    onKeyDown={handleKeyDown}
                    role="button"
                    tabIndex={0}
                >
                    <ChevronRightIcon
                        style={{
                            transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
                            marginRight: '.5rem'
                        }}
                        color={theme.tokens.BaseColorBlue700}
                        className="chevron-icon"
                        data-testid={expandableId}
                        fontSize={12}
                    />
                    <Typography variant="h5" color={theme.tokens.BaseColorBlue700} sx={{ marginBottom: '2px' }}>
                        {OUTSIDE_LIENHOLDER_HEADER_NAME}
                    </Typography>
                </ToggleHeaderAction>
            </ToggleHeaderContainer>
        </>
    );
};
